import './courses.css';
import coursesBanner from '../../assets/img/jpg/courses_banner.jpg';
import imagePlaceholder from '../../assets/img/jpg/img_placeholder.jpg';
import { useEffect, useState } from "react";
import { Header } from "../../components/header/Header";
import { useServer } from "../../context/serverContext";
import { endpoints } from "../../env";
import { useLang } from '../../context/LangContext';
import { CourseItem } from '../../components/CourseItem/CourseItem';
import { useAuth } from '../../context/AuthContext';
import { BarLoader } from '../../components/BarLoader/BarLoader';
import { Footer } from '../../components/footer/Footer';

export function Courses() {
    //HOOKS
    const { getRequest } = useServer();
    const { lang } = useLang();
    const { user } = useAuth();

    //STATES
    const [courses, setCourses] = useState([]);
    const [ownCourses, setOwnCourses] = useState([]);
    const [loading, setLoading] = useState(false);
 
    //EFFECTS
    useEffect(() => {
        setLoading(true);
        getRequest(endpoints.getCourses, {}, (res) => {
            setLoading(false);
            if (res[0]) {
                res = res[1];
                setCourses(res.courses);
                setOwnCourses(res.member);
            } else {

            }
        });
    }, []);

    return (
        <>
            <Header />
            <div className="courses_banner">
                <img src={coursesBanner} alt='' />
                <h1>
                    { lang === "en" ? "ACADEMIES" : "ACADEMIAS" }
                </h1>
            </div>

            {user &&
                (
                    <section className='courses_section own'>
                        <h2>
                            { lang === "en" ? "MY ACADEMIES" : "MIS ACADEMIAS" }
                        </h2>
                        {loading &&
                            (
                                <div className='loader'>
                                    <BarLoader />
                                </div>
                            )
                        }
                        <div className='courses_container'>
                            {
                                ownCourses.map((course, index) => {
                                    return <CourseItem course={course} key={'course_item_own_' + course.id} />
                                })
                            }
                        </div> 
                    </section>
                )
            }

            <section className='courses_section'>
                <h2>
                    { lang === "en" ? "ALL ACADEMIES" : "TODAS LAS ACADEMIAS" }
                </h2>
                {loading &&
                    (
                        <div className='loader'>
                            <BarLoader />
                        </div>
                    )
                }
                <div className='courses_container'>
                    {
                        courses.map((course, index) => {
                            return <CourseItem course={course} key={'course_item_' + course.id} />
                        })
                    }
                </div>
            </section>

            <Footer />
        </>
    );
}